/**
 * Label Localization System
 * 
 * Cho phép thay đổi các nhãn hiển thị dựa trên môi trường khách hàng (CLIENT_ENV).
 * Ví dụ: VAVC muốn hiển thị "Mặt đường" thay vì "Mặt tiền"
 */

// Label mapping configuration by CLIENT_ENV
const labelMappings = {
    vavc: {
        // Mặt tiền -> Mặt đường
        'Mặt tiền': 'Mặt đường',
        'mặt tiền': 'mặt đường',
        'MẶT TIỀN': 'MẶT ĐƯỜNG',
        'Chiều rộng mặt tiền': 'Chiều rộng mặt đường',
        'chiều rộng mặt tiền': 'chiều rộng mặt đường',
        'Chiều dài mặt tiền': 'Chiều dài mặt đường',
        'chiều dài mặt tiền': 'chiều dài mặt đường',
        'Mô tả mặt tiền': 'Mô tả mặt đường',
        'mô tả mặt tiền': 'mô tả mặt đường',
        'Tiếp giáp mặt tiền': 'Tiếp giáp mặt đường',
        'tiếp giáp mặt tiền': 'tiếp giáp mặt đường',
        'Mặt tiền tuyến đường chính': 'Mặt đường tuyến đường chính',
        'mặt tiền tuyến đường chính': 'mặt đường tuyến đường chính',
        'Vui lòng chọn mặt tiền': 'Vui lòng chọn mặt đường',
        'Vui lòng nhập chiều rộng mặt tiền': 'Vui lòng nhập chiều rộng mặt đường',
        'Mặt tiền & hẻm': 'Mặt đường & ngõ',
        'mặt tiền & hẻm': 'mặt đường & ngõ',
        
        // Hẻm -> Ngõ
        'Hẻm': 'Ngõ',
        'hẻm': 'ngõ',
        'HẺM': 'NGÕ',
        'Trong hẻm': 'Trong ngõ',
        'trong hẻm': 'trong ngõ',
        'Bề rộng hẻm': 'Bề rộng ngõ',
        'bề rộng hẻm': 'bề rộng ngõ',
        'Thông tin hẻm': 'Thông tin ngõ',
        'thông tin hẻm': 'thông tin ngõ',
        'Hẻm đầu nối': 'Ngõ đầu nối',
        'hẻm đầu nối': 'ngõ đầu nối',
        'Hẻm số': 'Ngõ số',
        'hẻm số': 'ngõ số',
        'Tiếp giáp hẻm': 'Tiếp giáp ngõ',
        'tiếp giáp hẻm': 'tiếp giáp ngõ',
        'Vui lòng nhập thông tin quẹo/hẻm': 'Vui lòng nhập thông tin quẹo/ngõ',

        // Mô tả tứ cận -> Số mặt thoáng
        'Mô tả tứ cận': 'Số mặt thoáng',
        'mô tả tứ cận': 'số mặt thoáng',

        // Mô tả khác -> Cơ sở hạ tầng kỹ thuật, giao thông
        'Mô tả khác': 'Cơ sở hạ tầng kỹ thuật, giao thông',
        'mô tả khác': 'cơ sở hạ tầng kỹ thuật, giao thông',

        'Ưu điểm': 'Cơ sở hạ tầng kỹ thuật, giao thông',
        'ưu điểm': 'cơ sở hạ tầng kỹ thuật, giao thông',
    }
};

/**
 * Localize a label based on the current CLIENT_ENV
 * @param {string} label - The original label to localize
 * @returns {string} - The localized label or original if no mapping exists
 */
export function localizeLabel(label) {
    if (!label || typeof label !== 'string') return label;
    
    const clientEnv = process.env.CLIENT_ENV;
    const mapping = labelMappings[clientEnv];
    
    if (!mapping) return label;
    
    // Try exact match first (most common case)
    if (mapping[label] !== undefined) {
        return mapping[label];
    }
    
    // Try partial replacement for dynamic strings
    let result = label;
    
    // Sort keys by length (longest first) to avoid partial replacements
    const sortedKeys = Object.keys(mapping).sort((a, b) => b.length - a.length);
    
    for (const original of sortedKeys) {
        if (result.includes(original)) {
            result = result.split(original).join(mapping[original]);
        }
    }
    
    return result;
}

/**
 * Vue plugin for easy usage in templates: {{ $l('Mặt tiền') }}
 */
export const LabelLocalizationPlugin = {
    install(Vue) {
        Vue.prototype.$l = localizeLabel;
        
        // Also add as a global mixin for computed usage
        Vue.mixin({
            methods: {
                $localizeLabel: localizeLabel
            }
        });
    }
};

/**
 * Check if we need to do label localization for current environment
 * @returns {boolean}
 */
export function hasLabelLocalization() {
    return !!labelMappings[process.env.CLIENT_ENV];
}

/**
 * Get all label mappings for current environment
 * @returns {Object|null}
 */
export function getLabelMappings() {
    return labelMappings[process.env.CLIENT_ENV] || null;
}

export default {
    localizeLabel,
    LabelLocalizationPlugin,
    hasLabelLocalization,
    getLabelMappings
};
